import { gql } from '@apollo/client';

export const GET_LOCATION_DETAILS = gql`
  query locationDetails(
    $countryCode: String
    $subdivision: String
    $city: String
    $search: String
    $tag: String
  ) {
    locationDetails(
      countryCode: $countryCode
      subdivision: $subdivision
      city: $city
      search: $search
      tag: $tag
    ) {
      title
      description
      image
      coverAlt
      attribution
      unsplashUser
      blurHash
      blur
      budgetScore
      isFeatured
      subtitle
      url
      license
      sublocations {
        subdivision
        city
      }
      topics
      countryCode
      viatorId
      guruSlug
      currencies {
        name
        symbol
        isoCurrencyCode
        dollarExchangeRate
      }
      languages
      englishProficiency
      timeZones {
        utcOffset
        timeZoneName
      }
      mustTryDishes
      atms {
        atmFees
        feeFreeAtms
        expensiveAtms
        comment
        banks {
          name
          limit
          feeFixed
          feePercent
        }
      }
      cardAcceptance
      drivingSide
      capitalCity
      population
      plugTypes
      travelTimes {
        monthRange
        seasonDescription
      }
      funFact
      images {
        url
        blur
        alt
      }
      body
      topThingsToDo {
        activity
        externalLink
      }
      faq {
        questionName
        acceptedAnswerText
      }
      travelEtiquette {
        dos
        donts
      }
      bbox
      budget {
        hostelDormMedianPrice
        takeawayMeal
        localPublicTransport
        longDistanceTransport
        attractions
        beerPrice
        airbnbOneNightMedianPrice
        deliveryMeal
        taxiRide
        coffeePrice
        hotelMedianPrice
        rentalCar
        organizedTour
        restaurantMeal
        fiveStarHotelMedianPrice
        fineDining
        privateDriver
        privateDayTrip
      }
    }
  }
`;

export const TRAVEL_GUIDE_EXISTS = gql`
  query locationDetails($countryCode: String) {
    locationDetails(countryCode: $countryCode) {
      title
      currencies {
        name
      }
      image
      blur
    }
  }
`;

export const GET_DESTINTATIONS = gql`
  query locations {
    locations {
      title
      image
      description
      regions
      countryCode
      blur
      isFeatured
    }
  }
`;

export const GET_FEATURED_LOCATIONS = gql`
  query featuredLocations(
    $communities: Boolean
    $countries: Boolean
    $places: Boolean
  ) {
    featuredLocations(
      communities: $communities
      countries: $countries
      places: $places
    ) {
      blurHash
      title
      image
      tag
      countryCode
      subdivision
      city
      suburb
    }
  }
`;

export const ADD_LOCATION_DETAILS = gql`
  mutation addLocationDetails($locationDetails: LocationDetailInput!) {
    addLocationDetails(locationDetails: $locationDetails) {
      success
      message
    }
  }
`;

export const FEATURED_IN_COUNTRY = gql`
  query featuredInCountry($countryCode: String!) {
    featuredInCountry(countryCode: $countryCode) {
      title
      image
      blur
      subdivision
      city
    }
  }
`;
